<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="true"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
  <div class="container-fluid  p-0" *ngIf="!isLoading()">
    <div class="row m-t-xs">
      <div class="col-12">
        <!-- <p-panel>
          <p-header>
            <span class="leyenda float-right"
              >{{ 'Audit.total' | translate }} {{ types ? types.length : '0' }}
              informes</span
            >
          </p-header> -->
        <!-- <div class="row">
            <div class="col-12">
              <input type="text" class="p-inputtext w-100" placeholder="{{ 'Documents.write.filter' | translate }}" name="filterText" id="filterTextInput" autocomplete="off" [(ngModel)]="filterText" (ngModelChange)="updateFilter()" />
            </div>
          </div> -->
        <p-table [value]="types" [responsive]="true">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th class="col-icon"></th>
              <th *ngIf="!customizeTableMode" class=""></th>
              <th *ngIf="!customizeTableMode" class=""></th>
              <th *ngIf="!customizeTableMode" class="">{{ 'ExpenseDocumentTypes.table.column.sign' | translate }}</th>
              <th *ngIf="!customizeTableMode" class="" style="width: 65%"> {{
                'ExpenseDocumentTypes.table.column.description' | translate }}</th>
              <th *ngIf="customizeTableMode" class="" style="width: 65%"> {{
                'ExpenseDocumentTypes.table.column.description' | translate }}</th>
              <th *ngIf="customizeTableMode" class="">{{ 'ExpenseDocumentTypes.table.column.documentType' | translate }}
              </th>
              <th *ngIf="customizeTableMode" class="">{{ 'ExpenseDocumentTypes.table.column.sign' | translate }}</th>
              <th class="col-actions"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-type>
            <tr>
              <td class="col-icon">
                <span><i class="fa fa-chart-bar fa-lg"></i><span class="sr-only"></span>
                </span>
              </td>
              <td *ngIf="!customizeTableMode">{{ type.childDocumentClass.abbreviation }}</td>
              <td *ngIf="customizeTableMode">{{ type.childDocumentClass.abbreviation }} - {{
                type.childExpenseDocumentType.description }}</td>
              <td>{{ type.childExpenseDocumentType.documentType }} </td>
              <td *ngIf="customizeTableMode">{{ (type.childSign) ? 'Negativo': 'Positivo' }}</td>
              <td *ngIf="!customizeTableMode">{{getSign(type)}}</td>
              <td *ngIf="!customizeTableMode">{{ type.childExpenseDocumentType.description }}</td>
              <td>
                <button class="btn  btn-primary btn-sm t-action-button" (click)="selectType(type)"
                  title="{{ 'General.open' | translate}}">
                  <i class="fas fa-plus" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr class="text-center">
              <td [attr.colspan]="(columns) ? columns.length : 1"> {{ 'General.noFilteredData' | translate }} </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- </p-panel> -->
      </div>
    </div>
  </div>
</p-scrollPanel>